<template>
  <article class="car-list-box mb-30" v-show="configData.carImg">
    <div class="car-head">
      <img :src="configData.img" alt="">
    </div>
    <div class="car-list-body">
      <ul class="car-img-detail">
        <li
          @click="changeVehicle({typeName: 'buy', datas: configData, btnText: configData.btnText })"
        >
          <div class="img-group-box">
            <img :src="configData.carImg" alt="">
            <div class="footer-box">
              <div class="left-tit">
                <p>{{configData.carName}}</p>
                <p>{{configData.carIntroduce}}</p>
              </div>
              <div class="hll-submit-btn">
                <img class="default-img" :src="configData.btnBackImg" alt="">
                <span>{{submitTimeValue ? '已预约' : configData.btnText}}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <!-- <p class="car-tip">注：以上优惠仅限置换新车使用，换新车型仅限于东风风行菱智V3厢式货车</p> -->
      <p class="car-tip">{{configData.introduce}}</p>
    </div>
  </article>
</template>

<script>
export default {
  props: ['configData', 'submitTimeValue'],
  methods: {
    changeVehicle () {
      this.$emit('changeVehicle', ...arguments)
    },
  }
}
</script>
